module.exports = __webpack_public_path__ + "static/media/atharva_phand.44f2eedc.jpg";